import { styled } from "@mui/material/styles";
import { FormControlLabel } from "@mui/material";
import colors from "../../theme/colors";

export const StyledFormControlLabel = styled(FormControlLabel)`
  color:${colors.gray[800]},
`
